import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';

import http from '../shared/http';
import intl from '../shared/intl';

import checkPermissions from '../shared/check-permissions';
import endpoints from '../../config/endpoints';
import {createSelectOptionsFromSysEnums} from '../shared/form-elements/select';

// actions types
const FETCH_DATA_SUCCESS = 'promoCodes/fetch-data-success';
const FETCH_DATA_ERROR = 'promoCodes/fetch-data-error';
const LOCATION_LOOKUP_FETCH_SUCCESS = 'promoCodes/LOCATION_LOOKUP_FETCH_SUCCESS';
const LOCATION_LOOKUP_FETCH_ERROR = 'promoCodes/LOCATION_LOOKUP_FETCH_ERROR';

const SUBMIT_SUCCESS = 'promoCodes/submit-success';
const SUBMIT_ERROR = 'promoCodes/submit-error';

const REMOVE_SUCCESS = 'promoCodes/remove-success';
const REMOVE_ERROR = 'promoCodes/remove-error';

const TOGGLE_FORM = 'promoCodes/TOGGLE_FORM';

const TOGGLE_PROGRESS_BAR = 'promoCodes/toggle-progress-bar';

// permissions
export const allowedPermissions = {
	'contestView': 'contest_view',
	'contestEdit': 'contest_edit'
};

// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	isFormOpen: false,
	table: {
		columns: {
			id: {
				index: 'id',
				title: 'ID',
				direction: 'asc'
			},
			name: {
				index: 'name',
				title: 'Name',
				direction: 'asc'
			},
			actions: {
				title: 'Actions'
			}
		}
	},
	form: {},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: (props) => (dispatch, getState) => {

			const url = document.location.pathname.includes('monthly-cashback')
				? 'v2/promo-codes/monthly-cashback'
				: 'v2/promo-codes';

			return (http({
				url: url,
				method: 'get',
				actions: [
					FETCH_DATA_SUCCESS,
					FETCH_DATA_ERROR
				]
			}))(dispatch);
		},

		submitForm: (formData) => (dispatch, getState) => {
			const data = { ...formData, country_id: _get(formData, 'country_id.0.value', null) };

			const request = http({
				url: 'v2/promo-codes',
				method: 'post',
				actions: [
					SUBMIT_SUCCESS,
					SUBMIT_ERROR
				],
				data: data
			});

			return request(dispatch)
				.then(action => {
					if (action.type === SUBMIT_SUCCESS) {
						dispatch(actions.fetchData());
						dispatch(actions.toggleForm());
					}
				});
		},

		remove: id => dispatch => {
			const request = http({
				url: `v2/promo-codes/${id}`,
				method: 'delete',
				actions: [
					REMOVE_SUCCESS, REMOVE_ERROR
				]
			});

			dispatch(actions.toggleProgressBar());

			request(dispatch)
				.then(action => {
					if (action.type === REMOVE_SUCCESS) {
						dispatch(actions.fetchData());
					}
				});
		},
		locationsLookups: text => (dispatch, getState) => {
			const request = http({
				url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
				method: 'get',
				actions: [ LOCATION_LOOKUP_FETCH_SUCCESS, LOCATION_LOOKUP_FETCH_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === LOCATION_LOOKUP_FETCH_SUCCESS) {
					const { data } = action.payload;

					return {
						options: createSelectOptionsFromSysEnums(data)
					};
				}
			});
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),
		toggleForm: (e) => (dispatch)=> {
			dispatch({
				type: TOGGLE_FORM
			});
		}
	}
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: action.payload.data, showProgressBar: false, error: false };
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_FORM]: (state, action) => ({ ...state, isFormOpen: !state.isFormOpen }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[REMOVE_SUCCESS]: state => ({...state, data: null}),
		[REMOVE_ERROR]: state => ({...state, error: true}),
		[SUBMIT_ERROR]: (state, action) => {
			const { response: {status = null, data = null} } = action.payload;
			if (status === 400 && !!data) return state;
			return { ...state, error: true };
		}
	}
);
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.promoCodes.data,
	getIsFormOpen: state => state.promoCodes.isFormOpen,
	getIntl: state => intl(state),
	getProgressBar: state => state.promoCodes.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.promoCodes.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/promo-codes/index.js